import { FieldTypes } from '../../../constants/FieldTypes'
import { CheckboxField, DateField, DropdownField, TextAreaField, TextField } from '../../../types'
import { ReturnVisitInterval, RiskAssessment } from '../types'

export const riskAssessmentField: DropdownField<RiskAssessment> = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'no-risk', text: 'No Risk' },
    { id: 'risk', text: 'Risk' },
    { id: 'further-evaluation-needed', text: 'Further Evaluation Needed' },
  ],
  placeholder: 'Risk Assessment',
}

export const isDraftField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Is Draft',
}

export const encounterDateField: DateField = {
  type: FieldTypes.DATE,
  isoFormat: true,
  placeholder: 'Encounter Date',
  defaultToNow: true,
}

export const chiefComplaintField: TextAreaField = {
  type: FieldTypes.TEXTAREA,
  placeholder: 'Chief Complaint',
}

export const hasReviewOfSystemsField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Review of Systems',
  size: 'lg',
}

export const patientConcernsTextField: TextAreaField = {
  type: FieldTypes.TEXTAREA,
  placeholder: "Patient's Concerns / Questions",
  hints: [{ text: "Document the patient's own words" }],
}

// §2.1: Do Not Bill — available at the authentication screen for all visit types.
// Flags the encounter as Provider Hold in the billing dashboard.
export const doNotBillField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Do not submit this visit for billing',
  optional: true,
}

// §2.2: Reason for Visit for routine antepartum visits — auto-populated from chart data,
// provider confirms or edits with one tap. Tier 1.
export const reasonForVisitField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Reason for Visit',
  hints: [{ text: 'Auto-populated from chart. Confirm or edit before saving.' }],
}

export const returnVisitIntervalField: DropdownField<ReturnVisitInterval> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Return Visit Interval',
  inputType: 'radio',
  optional: true,
  options: [
    { id: '1-week', text: '1 Week' },
    { id: '2-weeks', text: '2 Weeks' },
    { id: '4-weeks', text: '4 Weeks' },
    { id: 'prn', text: 'PRN' },
  ],
  warningMessage: 'Return visit interval should be documented for continuity of care.',
}
